import { useCallback, useEffect, useState } from "react";
import { api, mesajEroare } from "./api.js";
import { tr } from "./i18n.js";

const DECIZIE = ["ADMIN_TENANT", "MANAGER_TEHNIC"];
const CONDUCERE = [...DECIZIE, "COORDONATOR"];

const min = (n) => `${Math.round(n ?? 0)} min`;

/** Semnul contează mai mult decât cifra: peste normă e roșu, sub normă e verde. */
function clasaAbatere(procent) {
  if (procent > 20) return "abatere-mare";
  if (procent > 0) return "abatere-mica";
  return "abatere-buna";
}

const semn = (n) => (n > 0 ? `+${n}` : String(n));

export default function Abateri({ eu }) {
  const [sub, setSub] = useState("operatii");
  const poateDecide = DECIZIE.includes(eu.rol);

  return (
    <div className="continut">
      <h2>{tr("Estimat vs. realizat")}</h2>
      <p className="subtitlu">
        {tr("Cât s-a estimat și cât s-a lucrat de fapt. O operație cu mediana la 145% din normă, pe douăzeci de execuții, e o normă greșită — nu douăzeci de tehnicieni leneși. De-aia aplicația propune, iar decizia rămâne a unui om.")}
      </p>

      <div className="taburi-sisteme">
        <button className={`tab-sistem ${sub === "operatii" ? "activ" : ""}`}
          onClick={() => setSub("operatii")}>{tr("Pe operație")}</button>
        {CONDUCERE.includes(eu.rol) && (
          <button className={`tab-sistem ${sub === "oameni" ? "activ" : ""}`}
            onClick={() => setSub("oameni")}>{tr("Pe om")}</button>
        )}
        <button className={`tab-sistem ${sub === "clienti" ? "activ" : ""}`}
          onClick={() => setSub("clienti")}>{tr("Pe client")}</button>
        <button className={`tab-sistem ${sub === "norme" ? "activ" : ""}`}
          onClick={() => setSub("norme")}>{tr("Norme propuse")}</button>
      </div>

      {sub === "operatii" && <PeOperatie />}
      {sub === "oameni" && <PeOm />}
      {sub === "clienti" && <PeClient />}
      {sub === "norme" && <Norme poateDecide={poateDecide} />}
    </div>
  );
}

function PeOperatie() {
  const [lista, setLista] = useState(null);
  const [eroare, setEroare] = useState("");

  useEffect(() => {
    api.abateriPerOperatie().then(setLista).catch((e) => { setEroare(mesajEroare(e)); setLista([]); });
  }, []);

  if (lista === null) return <div className="gol">{tr("Se încarcă…")}</div>;

  return (
    <>
      {eroare && <div className="eroare">{eroare}</div>}
      <div className="panou tabel-derulabil">
        {lista.length === 0 ? (
          <div className="gol">
            {tr("Nicio operație măsurată încă. Abaterea se scrie la validarea fiecărei fișe — apare aici pe măsură ce se lucrează.")}
          </div>
        ) : (
          <table className="tabel">
            <thead>
              <tr><th>{tr("Operație")}</th><th className="num">{tr("Normă")}</th><th className="num">{tr("Mediana reală")}</th>
                <th className="num">{tr("Abatere")}</th><th className="num">{tr("Execuții")}</th><th></th></tr>
            </thead>
            <tbody>
              {lista.map((o) => (
                <tr key={o.operatieId}>
                  <td>{tr(o.denumire)}<span className="cod-mic">{o.cod}</span></td>
                  <td className="num">{min(o.normaCurenta)}</td>
                  <td className="num">{min(o.medianaRealizat)}</td>
                  <td className={`num ${clasaAbatere(o.abatereProcent)}`}>
                    {semn(o.abatereProcent)}%
                  </td>
                  <td className="num">{o.nrExecutii}</td>
                  <td>
                    {o.meritaRecalibrata && (
                      <span className="marcaj marcaj-atentie">{tr("merită recalibrată")}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

function PeOm() {
  const [lista, setLista] = useState(null);
  const [eroare, setEroare] = useState("");

  useEffect(() => {
    api.abateriPerTehnician().then(setLista).catch((e) => { setEroare(mesajEroare(e)); setLista([]); });
  }, []);

  if (lista === null) return <div className="gol">{tr("Se încarcă…")}</div>;

  return (
    <>
      {eroare && <div className="eroare">{eroare}</div>}

      <div className="panou panou-atentie"><div className="panou-corp">
        <strong>{tr("Instrument de îndrumare, nu de sancțiune.")}</strong> {tr("Cifrele de aici nu se expun clientului, în niciun raport, și nu se compară între colegi în afara echipei. Cine lucrează constant sub normă la operații de siguranță e un semnal de calitate, nu de performanță — se citește împreună cu rata de revenire, nu singur.")}
      </div></div>

      <div className="panou tabel-derulabil">
        {lista.length === 0 ? (
          <div className="gol">{tr("Nicio măsurătoare atribuită unui tehnician anume.")}</div>
        ) : (
          <table className="tabel">
            <thead>
              <tr><th>{tr("Tehnician")}</th><th className="num">{tr("Operații")}</th>
                <th className="num">{tr("Estimat")}</th><th className="num">{tr("Lucrat")}</th>
                <th className="num">{tr("Abatere")}</th></tr>
            </thead>
            <tbody>
              {lista.map((t) => (
                <tr key={t.tehnicianId}>
                  <td>{t.numeComplet}</td>
                  <td className="num">{t.nrOperatii}</td>
                  <td className="num">{min(t.totalNormaMinute)}</td>
                  <td className="num">{min(t.totalRealizatMinute)}</td>
                  <td className={`num ${clasaAbatere(t.abatereProcent)}`}>
                    {semn(t.abatereProcent)}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

function PeClient() {
  const [lista, setLista] = useState(null);
  const [eroare, setEroare] = useState("");

  useEffect(() => {
    api.abateriPerClient().then(setLista).catch((e) => { setEroare(mesajEroare(e)); setLista([]); });
  }, []);

  if (lista === null) return <div className="gol">{tr("Se încarcă…")}</div>;

  return (
    <>
      {eroare && <div className="eroare">{eroare}</div>}
      <p className="subtitlu">
        {tr("Cât durează")} <em>{tr("în realitate")}</em> {tr("o lucrare la fiecare client. Următoarea ofertă poate pleca de aici, nu de la o presupunere.")}
      </p>
      <div className="panou tabel-derulabil">
        {lista.length === 0 ? (
          <div className="gol">{tr("Nicio măsurătoare încă.")}</div>
        ) : (
          <table className="tabel">
            <thead>
              <tr><th>{tr("Client")}</th><th className="num">{tr("Operații")}</th>
                <th className="num">{tr("Estimat")}</th><th className="num">{tr("Lucrat")}</th>
                <th className="num">{tr("Abatere")}</th></tr>
            </thead>
            <tbody>
              {lista.map((c) => (
                <tr key={c.clientId}>
                  <td>{tr(c.denumire)}</td>
                  <td className="num">{c.nrOperatii}</td>
                  <td className="num">{min(c.totalNormaMinute)}</td>
                  <td className="num">{min(c.totalRealizatMinute)}</td>
                  <td className={`num ${clasaAbatere(c.abatereProcent)}`}>
                    {semn(c.abatereProcent)}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

function Norme({ poateDecide }) {
  const [lista, setLista] = useState(null);
  const [eroare, setEroare] = useState("");
  const [mesaj, setMesaj] = useState("");
  const [lucreaza, setLucreaza] = useState(false);
  const [deschisa, setDeschisa] = useState(null);

  const reincarca = useCallback(async () => {
    try { setLista(await api.normePropuse()); setEroare(""); }
    catch (e) { setEroare(mesajEroare(e)); setLista([]); }
  }, []);

  useEffect(() => { reincarca(); }, [reincarca]);

  async function recalculeaza() {
    setLucreaza(true); setMesaj(""); setEroare("");
    try {
      const r = await api.recalculeazaNorme();
      setMesaj(r.noi === 0 && r.actualizate === 0
        ? `Nicio normă nu deviază destul ca să merite o propunere `
          + `(prag: ±${r.prag.abatereMinimaProcent}% pe cel puțin ${r.prag.executiiMinime} execuții).`
        : tr("{0} propuneri noi, {1} aduse la zi.", r.noi, r.actualizate));
      await reincarca();
    } catch (e) { setEroare(mesajEroare(e)); }
    finally { setLucreaza(false); }
  }

  if (lista === null) return <div className="gol">{tr("Se încarcă…")}</div>;

  return (
    <>
      {eroare && <div className="eroare">{eroare}</div>}
      {mesaj && <div className="panou panou-atentie"><div className="panou-corp">{mesaj}</div></div>}

      {poateDecide && (
        <div className="linie-actiune">
          <button className="buton buton-actiune" disabled={lucreaza} onClick={recalculeaza}>
            {tr("recalculează medianele")}
          </button>
        </div>
      )}

      <div className="panou tabel-derulabil">
        {lista.length === 0 ? (
          <div className="gol">
            {tr("Nicio propunere. Aplicația propune o normă nouă doar când mediana deviază peste prag, pe destule execuții — o listă care crește la fiecare rulare s-ar închide fără să fie citită.")}
          </div>
        ) : (
          <table className="tabel">
            <thead>
              <tr><th>{tr("Operație")}</th><th className="num">{tr("Normă")}</th><th className="num">{tr("Mediana")}</th>
                <th className="num">{tr("Abatere")}</th><th className="num">{tr("Execuții")}</th>
                <th>{tr("Stare")}</th>{poateDecide && <th></th>}</tr>
            </thead>
            <tbody>
              {lista.map((p) => (
                <tr key={p.id}>
                  <td>{tr(p.operatie.denumire)}<span className="cod-mic">{p.operatie.cod}</span></td>
                  <td className="num">{min(p.normaCurenta)}</td>
                  <td className="num">{min(p.medianaRealizat)}</td>
                  <td className={`num ${clasaAbatere(Number(p.abatereProcent))}`}>
                    {semn(Number(p.abatereProcent))}%
                  </td>
                  <td className="num">{p.nrExecutii}</td>
                  <td>
                    {p.status === "Propusa" ? <span className="marcaj">{tr("de decis")}</span>
                      : p.status === "Acceptata"
                        ? <>{tr("aplicată:")} {min(p.normaAplicata)}<span className="cod-mic">
                          {p.decisDe?.numeComplet}</span></>
                        : <>{tr("respinsă")}<span className="cod-mic">{p.decisDe?.numeComplet}</span></>}
                  </td>
                  {poateDecide && (
                    <td>
                      {p.status === "Propusa" && (
                        <button className="buton buton-mic buton-sters"
                          onClick={() => setDeschisa(p)}>{tr("decide")}</button>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {deschisa && (
        <Decizie propunere={deschisa} inchide={() => setDeschisa(null)}
          gata={async () => { setDeschisa(null); await reincarca(); }} />
      )}
    </>
  );
}

function Decizie({ propunere, inchide, gata }) {
  const [motiv, setMotiv] = useState("");
  const [norma, setNorma] = useState(String(propunere.normaPropusa));
  const [eroare, setEroare] = useState("");
  const [lucreaza, setLucreaza] = useState(false);

  async function fa(fn) {
    setLucreaza(true); setEroare("");
    try { await fn(); await gata(); }
    catch (e) { setEroare(mesajEroare(e)); }
    finally { setLucreaza(false); }
  }

  const scurt = motiv.trim().length < 5;

  return (
    <div className="modal-fundal" onClick={inchide}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>{tr(propunere.operatie.denumire)}</h3>
        <p className="subtitlu">
          {tr("Norma de acum e")} {min(propunere.normaCurenta)}{tr(". Pe")} {propunere.nrExecutii} {tr("execuții, mediana reală e")} {min(propunere.medianaRealizat)} {tr("— cu")}{" "}
          {semn(Number(propunere.abatereProcent))}%.
        </p>

        {eroare && <div className="eroare">{eroare}</div>}

        <label className="camp">
          {tr("norma care se aplică (poți ajusta — datele spun ce s-a măsurat, nu ce e rezonabil să ceri iarna, pe acoperiș)")}
          <input type="number" min="1" value={norma}
            onChange={(e) => setNorma(e.target.value)} />
        </label>

        <label className="camp">
          {tr("motivul deciziei")}
          <textarea className="camp-textarea" rows={3} value={motiv}
            placeholder={tr("O normă schimbată fără motiv nu se poate apăra peste șase luni.")}
            onChange={(e) => setMotiv(e.target.value)} />
        </label>

        <p className="subtitlu">
          {tr("Fișele deja emise NU se recalculează: fiecare poartă norma de la momentul ei.")}
        </p>

        <div className="modal-actiuni">
          <button className="buton buton-sters" onClick={inchide}>{tr("renunță")}</button>
          <button className="buton buton-sters" disabled={lucreaza || scurt}
            onClick={() => fa(() => api.respingeNorma(propunere.id, { motiv: motiv.trim() }))}>
            {tr("respinge")}
          </button>
          <button className="buton" disabled={lucreaza || scurt || !norma}
            onClick={() => fa(() => api.acceptaNorma(propunere.id, {
              normaAplicata: Number(norma), motiv: motiv.trim(),
            }))}>
            {tr("acceptă")}
          </button>
        </div>
      </div>
    </div>
  );
}
